import { Route, Routes } from 'react-router';
import { useAuthContext } from '@contexts/auth';
import ProtectedRoute from '@components/ProtectedRoute';

import Login from './Login';
import OtpCode from './Otp';
import Registration from './Registration';
import Dashboard from './Dashboard';
import Customers from './Customers/Main';
import UpsertCustomer from './Customers/Upsert';
import CustomerDetails from './Customers/Details';
import Portfolio from './Portfolio';
import DispositionOption from './DispositionOption';
import Campaign from './Campaign';
import CampaignExecution from './CampaignExecution/Main';
import CampaignExecutionCustomerDetails from './CampaignExecution/CustomerDetails';
import User from './User/Main';
import UserRoles from './User/Roles';
import NotFound from './NotFound';
import ForgotPassword from './ForgotPassword';
import NewPassword from './NewPassword';

const AppRoutes = () => {
  const { checkIfHasRole } = useAuthContext();

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="inserir-codigo" element={<OtpCode />} />
      <Route path="cadastro/:code" element={<Registration />} />
      <Route path="esqueci-senha" element={<ForgotPassword />} />
      <Route path="nova-senha/:code" element={<NewPassword />} />

      <Route element={<ProtectedRoute />}>
        <Route path="painel" element={<Dashboard />}>
          {checkIfHasRole('CAN_VIEW_CUSTOMERS') && (
            <Route path="clientes">
              <Route index element={<Customers />} />
              {checkIfHasRole('CAN_CREATE_CUSTOMERS') && (
                <Route path="criar" element={<UpsertCustomer />} />
              )}
              {checkIfHasRole('CAN_EDIT_CUSTOMERS') && (
                <Route path="editar/:id" element={<UpsertCustomer />} />
              )}
              {checkIfHasRole('CAN_DETAIL_CUSTOMERS') && (
                <Route path=":id" element={<CustomerDetails />} />
              )}
            </Route>
          )}

          {checkIfHasRole('CAN_READ_PORTFOLIO') && (
            <Route path="portfolios" element={<Portfolio />} />
          )}

          {checkIfHasRole('CAN_READ_CAMPAIGNS') && (
            <Route path="campanhas" element={<Campaign />} />
          )}

          {checkIfHasRole('CAN_VIEW_CAMPAIGN_EXECUTION') && (
            <Route path="atendimentos">
              <Route index element={<CampaignExecution />} />
            {checkIfHasRole('CAN_PERFORM_CAMPAIGN_EXECUTION') && (
              <Route path=":id/cliente" element={<CampaignExecutionCustomerDetails />} />
            )}
            </Route>
          )}

          {checkIfHasRole('CAN_READ_TABULATION_OPTIONS') && (
            <Route path="opcoes-de-tabulacao" element={<DispositionOption />} />
          )}

          {checkIfHasRole('CAN_VIEW_USERS') && (
            <Route path="usuarios">
              <Route index element={<User />} />
            {checkIfHasRole('CAN_MANAGE_USERS') && (
              <Route path=":id/permissoes" element={<UserRoles />} />
            )}
            </Route>
          )}
        </Route>
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
